module.exports = __webpack_public_path__ + "media/images/tab_arrow2-d7ae3fe884bf26db743a17b76a8991e0.png";